import { Component, computed, input } from '@angular/core';
import { CigpStaff } from './cigp-staff.model';
import { randomCigpColor } from '../shared/utils';
import { NgStyle } from '@angular/common';

@Component({
  selector: 'eaa-cigp-staff-avatar-card',
  imports: [NgStyle],
  template: `
    @if (user(); as user) {
      <div class="d-flex gap-2 align-items-center">
        @if (user.profilePicture) {
          <img
            [src]="user.profilePicture"
            class="e-avatar e-avatar-circle"
            [alt]="user.displayName"
            [title]="title()"
            [ngStyle]="{ height: size, width: size }"
          />
        } @else {
          <div
            class="e-avatar e-avatar-circle text-white d-flex justify-content-center align-items-center"
            [ngStyle]="{ 'background-color': backgroundColor, height: size, width: size }"
            [title]="title()"
          >
            {{ user.initials }}
          </div>
        }

        @if (showName()) {
          <div>{{ user.displayName }}</div>
        }

        @if (showInitials()) {
          <div>{{ user.initials }}</div>
        }
      </div>
    } @else if (fallbackValue()) {
      <div>{{ fallbackValue() }}</div>
    }
  `,
  styles: `
    div.e-avatar {
      cursor: default;
    }
  `
})
export class CigpStaffAvatarCardComponent {
  protected backgroundColor = randomCigpColor();
  protected title = computed(() => this.user()?.displayName || '');

  public fallbackValue = input<string>();
  public showInitials = input<boolean>(false);
  public showName = input<boolean>(false);
  public size = input<string>('36px');
  public user = input<CigpStaff | null>(null);
}
